<template>
	<div class="container" id="profile">
		<SubpageHeader
			@on-back="actionBack"
		>
			プロフィール
		</SubpageHeader>
		<div class="row marginBottom20">
			<div class="col-xs-12">
				<!--
				<p class="formtxt">すべての項目をご記入・チェックの上、［プロフィール更新］ボタンをクリックして次の画面へお進みください。</p>
				-->
				<div class="panel panel-default">
					<div class="panel-heading">ユーザー基本情報</div>
					<div class="panel-body">
						<table class="table table-bordered table-block-xs">
							<tbody>
								<tr>
									<th><label for="user_login">ユーザ名</label></th>
									<td>{{dataUser.user_login}} <span class="description caution">ユーザー名は変更できません。</span></td>
								</tr>
								<tr>
									<th>名前&nbsp;<span class="label label-danger">必須</span></th>
									<td>
										<div class="input-group">
											<span class="input-group-addon">姓</span>
											<input type="text" name="last_name" id="last_name" placeholder="例）宮崎" v-model="dataUser.last_name" class="form-control" />
											<span class="input-group-addon">名</span>
											<input type="text" name="first_name" id="first_name" placeholder="例）太郎" v-model="dataUser.first_name" class="form-control" />
										</div>
										<span style="color:red">※日本国籍の方は必ず身分証等にある記載と同じ表記でご入力ください</span><br />
										<span style="color:red">※外国籍の方は一旦カタカナにてご入力の上、下記「名前ローマ字欄」にて英語表記でご入力ください。</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="panel panel-default">
					<div class="panel-heading">お問合わせ先</div>
					<div class="panel-body">
						<table class="table table-bordered table-block-xs">
							<tbody>
								<tr>
									<th>メール&nbsp;<span class="label label-danger">必須</span></th>
									<td>
										<input type="text" name="email" id="email" v-model="dataUser.email" class="form-control" />
										<p style="word-break: break-all;">※キャリアメール(@docomo.ne.jp,@ezweb.ne.jp,@softbank.ne.jp など)でご登録されると、迷惑メールの設定等で自動返信メールが届かないことがあるため、PCメールアドレスのご登録を推奨します。</p>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="panel panel-default">
					<div class="panel-heading">ユーザ補助情報</div>
					<div class="panel-body">
						<table class="table table-bordered table-block-xs">
							<tbody>
								<tr>
									<th>名前フリガナ&nbsp;<span class="label label-danger">必須</span></th>
									<td>
										<div class="input-group">
											<span class="input-group-addon">セイ</span>
											<input type="text" name="last_name_kana" placeholder="例）ミヤザキ" v-model="dataUser.last_name_kana" class="form-control" />
											<span class="input-group-addon">メイ</span>
											<input type="text" name="first_name_kana" placeholder="例）タロウ" v-model="dataUser.first_name_kana" class="form-control" />
										</div>
									</td>
								</tr>
								<tr>
									<th>名前ローマ字</th>
									<td>
										<div class="input-group">
											<span class="input-group-addon">セイ</span>
											<input type="text" name="last_name_roma" placeholder="例）MIYAZAKI" v-model="dataUser.last_name_roma" class="form-control" />
											<span class="input-group-addon">メイ</span>
											<input type="text" name="first_name_roma" placeholder="例）TARO" v-model="dataUser.first_name_roma" class="form-control" />
										</div>
									</td>
								</tr>
								<tr>
									<th>性別&nbsp;<span class="label label-danger">必須</span></th>
									<td class="form-inline">
										<div class="checkbox">
											<label><input type="radio" name="sex" value="男性" v-model="dataUser.sex" />男性</label>
										</div>
										<div class="checkbox">
											<label><input type="radio" name="sex" value="女性" v-model="dataUser.sex" />女性</label>
										</div>
									</td>
								</tr>
								<tr>
									<th>生年月日&nbsp;<span class="label label-danger">必須</span></th>
									<td class="form-inline">
										<select class="form-control" name="birth_year" v-model="dataUser.birth_year">
											<option v-for="year in listYear" :value="year.value" :key="year.value">{{year.label}}</option>
										</select>
										<select class="form-control" name="birth_month" v-model="dataUser.birth_month">
											<option v-for="month in listMonth" :value="month.value" :key="month.value">{{month.label}}</option>
										</select>
										<select class="form-control" name="birth_day" v-model="dataUser.birth_day">
											<option v-for="date in listDate" :value="date.value" :key="date.value">{{date.label}}</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>郵便番号&nbsp;<span class="label label-danger">必須</span></th>
									<td class="form-inline">
										<div class="input-group">
											<input class="form-control" placeholder="例)123-4567" style="min-width: 9em" type="text" name="zip_code" size="8" v-model="dataUser.zip_code">
										</div>
										半角数字でハイフンを除いてご記入ください。
										<input style="margin-top: 8px; margin-left: 8px" class="btnProfileAjaxZip3" value="住所検索" type="button" @click.prevent="actionZip">
									</td>
								</tr>
								<tr>
									<th>都道府県&nbsp;<span class="label label-danger">必須</span></th>
									<td>
										<input class="form-control" type="text" readonly name="province" size="8" v-model="dataUser.province" />
									</td>
								</tr>
								<tr>
									<th>市区町村&nbsp;<span class="label label-danger">必須</span></th>
									<td>
										<input class="form-control" type="text" readonly name="city" size="30" v-model="dataUser.city" />
									</td>
								</tr>
								<tr>
									<th>番地&nbsp;<span class="label label-danger">必須</span></th>
									<td>
										<input class="form-control" type="text" name="banchi" size="30" v-model="dataUser.banchi" />
									</td>
								</tr>
								<tr>
									<th>アパート、マンション名</th>
									<td>
										<input class="form-control" type="text" name="building" size="30" v-model="dataUser.building" />
										※参加通知書等の郵送に使用しますので、住所は部屋号室まで詳しく、お間違いのないようにご記入ください。<br />
										※英数字は半角でご記入ください。
									</td>
								</tr>
								<tr>
									<th>携帯電話&nbsp;<span class="label label-danger">必須</span></th>
									<td>
										<div class="input-group">
											<input class="form-control" placeholder="例)090" type="text" name="phone_1" size="6" v-model="dataUser.phone_1">
											<span class="input-group-addon">-</span>
											<input class="form-control" placeholder="例)1234" type="text" name="phone_2" size="6" v-model="dataUser.phone_2">
											<span class="input-group-addon">-</span>
											<input class="form-control" placeholder="例)5678" type="text" name="phone_3" size="7" v-model="dataUser.phone_3">
										</div>
										半角数字でご記入ください。（運営よりご連絡する場合がございますので、お間違いのないよう十分ご注意ください）
									</td>
								</tr>
								<tr>
									<th>日中連絡先</th>
									<td>
										<div class="input-group">
											<input class="form-control" placeholder="例)090" type="text" name="day_phone_1" size="6" v-model="dataUser.day_phone_1">
											<span class="input-group-addon">-</span>
											<input class="form-control" placeholder="例)1234" type="text" name="day_phone_2" size="6" v-model="dataUser.day_phone_2">
											<span class="input-group-addon">-</span>
											<input class="form-control" placeholder="例)5678" type="text" name="day_phone_3" size="7" v-model="dataUser.day_phone_3">
										</div>
										半角数字でご記入ください。
									</td>
								</tr>
								<tr>
									<th>職業</th>
									<td>
										<select class="form-control" name="job" v-model="dataUser.job">
											<option v-for="job,idx in listJob" :value="job" :key="idx" >{{job}}</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>お知らせ</th>
									<td class="form-inline">
										<div class="checkbox">
											<label><input type="checkbox" name="notification" value="on" v-model="dataUser.notification">UFENTRYシステムからのお知らせを受け取る</label>
										</div>
									</td>
								</tr>
							</tbody>
						</table>				
					</div>
				</div>

				<div class="text-center marginBottom20">
					<a class="btn btn-success" @click.prevent="actionSubmit">プロフィール更新</a>
				</div>

			</div>
		</div>
		<SelectZipAddr
			v-if="showSelectZipAddr"
			:list-addr="listSelectZipAddr"
			@select-addr="selectedAddr"
		></SelectZipAddr>
	</div>
<!--
	<div id="setupNewAddress">
		<div class="frameSetupNewAddress">
			<p>会員様の住所登録の構成を確認中です。<br />しばらくお待ちください。</p>
		</div>
	</div>
-->
</template>
<script>
	import SelectZipAddr from '@/components/selectZipAddr';
	import SubpageHeader from '@/components/SubpageHeader';

	export default {
		components: {
			SelectZipAddr,
			SubpageHeader
		},
		props: {
		},
		data() {
			return {
				'listJob': ["会社員", "公務員", "自営業", "学生", "アルバイト", "無職", "その他"],
				
				'uname': '',
				'pwd': '',
				
				'showSelectZipAddr': false,
				'listSelectZipAddr': []
			};
		},
		computed: {
			dataUser() {
				return this.$store.getters['commonStore/getDataUser'];
			},
			listYear() {
				const ret = [];
				let nyear = new Date().getFullYear();
				for(;nyear >= 2020; nyear--) {
					ret.push( {value:nyear, label: nyear+'年/令和'+(nyear-2019) });
				}
				ret.push( {value:nyear, label: nyear+'年/令和元'});
				nyear--;
				for(;nyear >= 1990; nyear--) {
					ret.push( {value:nyear, label: nyear+'年/平成'+(nyear-1988) });
				}
				ret.push( {value:nyear, label: nyear+'年/平成元'});
				nyear--;
				for(;nyear >= 1927; nyear--) {
					ret.push( {value:nyear, label: nyear+'年/昭和'+(nyear-1925) });
				}
				ret.push( {value:nyear, label: nyear+'年/昭和元'});
				nyear--;
				for(; nyear >= 1913; nyear--) {
					ret.push( {value:nyear, label: nyear+'年/大正'+(nyear-1911) });
				}
				ret.push( {value:nyear, label: nyear+'年/大正元'});
				nyear--;
				return ret;
			},
			listMonth() {
				const ret = [];
				for(let i = 1; i <= 12; i++) ret.push({value:i, label:i+'月'});
				return ret;
			},
			listDate() {
				const ret = [];
				for(let i = 1; i <= 31; i++) ret.push({value:i, label:i+'日'});
				return ret;
			},
			isLogin() {
				return this.$store.getters['commonStore/isLogin'];
			},
		},
		methods: {
			actionBack() {
				this.$router.push('/top');
			},
			async actionSubmit() {
				const rslt = await this.$store.dispatch('commonStore/validateProfile', this.dataUser);
				if(rslt.payload) {
					if(rslt.payload.error && Array.isArray(rslt.payload.error) && rslt.payload.error.length) {
						this.$dialog.alert(rslt.payload.error.join('<br />'),{okText: 'OK', html: true});
					} else {
						await this.$store.dispatch('commonStore/updateProfile', this.dataUser);
						this.actionBack();
					}
				}
			},
			async actionZip() {
				// zipcloud API のみでは反応が遅すぎるので
				// AjaxZip3との併用とする
				//var postno = $('input[name="zip_code"]').val();
				window.AjaxZip3.zip2addr('zip_code','','province','city');
				this.ajaxZip();
			},
			async ajaxZip() {
				const rslt = await this.$store.dispatch('commonStore/ajaxZip', this.dataUser.zip_code);
				if(rslt) {
					if(rslt.status == 200) {
						if(rslt.results === null) {
							this.$store.commit('commonStore/setProfileProvice', '');
							this.$store.commit('commonStore/setProfileCity', '');
						} else {
							if(rslt.results.length == 1) {
								const info = rslt.results[0];
								this.$store.commit('commonStore/setProfileProvice', info.address1);
								this.$store.commit('commonStore/setProfileCity', info.address2+info.address3);
							} else if(rslt.results.length > 1) {
								this.listSelectZipAddr = rslt.results;
								this.showSelectZipAddr = true;
							}
						}
					}
				}
			},
			selectedAddr(addr) {
				this.$store.commit('commonStore/setProfileProvice', addr.address1);
				this.$store.commit('commonStore/setProfileCity', addr.address2+addr.address3);
				this.showSelectZipAddr = false;
			}
		},
		mounted() {
			if(!this.isLogin) {
				this.$router.push('/login');
				return;
			}
			this.$store.dispatch('commonStore/profile');
		}
	};
</script>

<style lang="scss" scoped>
	#profile {
		padding-bottom: 20px;
		font-size: 12px;
		& > div {
			padding-top: 8px;
			padding-bottom: 8px;
		}
		table {
			th {
				width: 200px;
			}
		}
		.description.caution {
			color: #f00;
		}
		/*
		* テーブルを解像度にあわせてブロック表示にする
		*/
		@media (max-width: 767px) {
			table.table-block-xs {
				border: none;	/* th および td がブロック要素になることで、tableへのborder設定が行われると線が太くなる */
			}
			table.table-block-xs > tbody > tr > th,
			table.table-block-xs > tbody > tr > td {
				display: block !important;
				width: auto !important;
				border-bottom-width: 0px !important;
			}
			table.table-block-xs > tbody > tr:last-child > *:last-child {
				border-bottom-width: 1px !important;
			}
			table.table-block-xs > tbody > tr > th {
				background-color: #eee;
			}
			
			table.table-tworow-in-one-xs > tbody > tr:nth-child(odd) > th,
			table.table-tworow-in-one-xs > tbody > tr:nth-child(odd) > td {
				border-bottom-color: #eee;
				border-bottom-style: dotted;
			}
			table.table-tworow-in-one-xs > tbody > tr:nth-child(even) > th,
			table.table-tworow-in-one-xs > tbody > tr:nth-child(even) > td {
				border-top-color: #eee;
				border-top-style: dotted;
			}
		}

	}
</style>

